import { createFileRoute } from "@tanstack/react-router";
import { RelatorioLitragemColeta } from "pages/relatorios/pages/litragem_coleta";

export const Route = createFileRoute("/a/relatorios/litragem-coleta")({
	component: RelatorioLitragemColeta,
});
